export default "__VITE_PUBLIC_ASSET__52b3c7cc__"